export { ReactComponent as MenusIcon } from './alignment.svg'
export { ReactComponent as AppsIcon } from './apps.svg'
export { ReactComponent as BikeIcon } from './bike.svg'
export { ReactComponent as BoltIcon } from './bolt.svg'
export { ReactComponent as ComposerIcon } from './composer.svg'
export { ReactComponent as CalendarIcon } from './calendar.svg'
export { ReactComponent as CarIcon } from './car.svg'
export { ReactComponent as OrdersIcon } from './orders.svg'
export { ReactComponent as ClockIcon } from './clock.svg'
export { ReactComponent as DesignerIcon } from './designer.svg'
export { ReactComponent as Discounts } from './discounts.svg'
export { ReactComponent as TermsIcon } from './document-layout-left.svg'
export { ReactComponent as DownArrowIcon } from './down-arrow.svg'
export { ReactComponent as DraggableIcon } from './draggable.svg'
export { ReactComponent as DraggableLightIcon } from './draggable-light.svg'
export { ReactComponent as FilterIcon } from './filter.svg'
export { ReactComponent as HelpIcon } from './helpcenter.svg'
export { ReactComponent as HiddenIcon } from './hidden.svg'
export { ReactComponent as ImageIcon } from './image.svg'
export { ReactComponent as OverviewIcon } from './overview.svg'
export { ReactComponent as InsightsIcon } from './insights.svg'
export { ReactComponent as LayoutIcon } from './layout.svg'
export { ReactComponent as LeftArrowIcon } from './left-arrow.svg'
export { ReactComponent as LocationIcon } from './location.svg'
export { ReactComponent as MarkerIcon } from './marker.svg'
export { ReactComponent as MotorbikeIcon } from './motorbike.svg'
export { ReactComponent as PlusIcon } from './plus.svg'
export { ReactComponent as PowerIcon } from './power.svg'
export { ReactComponent as PreOrders } from './pre-orders.svg'
export { ReactComponent as PuzzleIcon } from './puzzle.svg'
export { ReactComponent as RadarIcon } from './radar.svg'
export { ReactComponent as RedesignIcon } from './re-design.svg'
export { ReactComponent as ReorderIcon } from './re-order.svg'
export { ReactComponent as RightArrowIcon } from './right-arrow.svg'
export { ReactComponent as SelectDownArrowIcon } from './select-down-arrow.svg'
export { ReactComponent as SettingsIcon } from './settings.svg'
export { ReactComponent as ShopIcon } from './shop.svg'
export { ReactComponent as SlerpLogo } from './slerp-logo.svg'
export { ReactComponent as SlerpPayLogo } from './slerp-pay.svg'
export { ReactComponent as StripeLogo } from './stripe-logo.svg'
export { ReactComponent as TagIcon } from './tag.svg'
export { ReactComponent as UpArrowIcon } from './up-arrow.svg'
export { ReactComponent as CustomersIcon } from './customers.svg'
export { ReactComponent as VanIcon } from './van.svg'
export { ReactComponent as Welcome } from './welcome.svg'
export { ReactComponent as Equalizer } from './equalizer.svg'
export { ReactComponent as PhoneMockup } from './phone-mockup.svg'
export { ReactComponent as ShareIcon } from './share.svg'
export { ReactComponent as ArchiveIcon } from './archive.svg'
export { ReactComponent as EditIcon } from './edit.svg'
export { ReactComponent as CheckIcon } from './check.svg'
export { ReactComponent as DownloadIcon } from './download.svg'
export { ReactComponent as CutOffIcon } from './cutoff.svg'
export { ReactComponent as MenuManagerIcon } from './menu-manager.svg'
export { ReactComponent as ChevronLeftIcon } from './chevrons-left.svg'
export { ReactComponent as ChevronRightIcon } from './chevrons-right.svg'
export { ReactComponent as TrashIcon } from './trash.svg'
export { ReactComponent as LogOutIcon } from './logout.svg'
export { ReactComponent as WindowIcon } from './window.svg'
export { ReactComponent as DiscountDeliveryChargeIcon } from './discount-delivery.svg'
export { ReactComponent as DiscountProductIcon } from './discount-product.svg'
export { ReactComponent as DiscountBasketIcon } from './discount-basket.svg'
export { ReactComponent as AppCampaignIcon } from './app-campaigns.svg'
export { ReactComponent as CRMIcon } from './crm.svg'
export { ReactComponent as DispatchIcon } from './dispatch.svg'
export { ReactComponent as PlusSquareIcon } from './u_plus-square.svg'
